import PropTypes from 'prop-types';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { deprecatedPropValues } from '../core/deprecated-prop-values.js';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * The type of callout
   */ variant: PropTypes.oneOf([
        'standard',
        'overlay',
        'inverse'
    ]),
    /**
   * @deprecated
   * use `size` prop instead
   */ sizeVariant: deprecatedProp(PropTypes.oneOf([
        'standard',
        'super',
        'mini'
    ]), DEPRECATED_PROP_MESSAGES.size),
    /**
   * The size variation
   *
   * 'super' option is deprecated - use the standard size instead
   */ size: deprecatedPropValues(PropTypes.oneOf([
        'standard',
        'super',
        'mini'
    ]), [
        'super'
    ], 'Omit or use the `standard` size'),
    /**
   * The visual style of the Callout
   */ skin: PropTypes.oneOf([
        'standard',
        'announcement',
        'discount',
        'holiday',
        'error',
        'new',
        'foil'
    ]),
    /**
   * The border of the Callout
   */ border: PropTypes.oneOf([
        'standard',
        'none'
    ]),
    /**
   * Whether or not the Callout should render its content with ALL CAPS
   *
   * @deprecated use `textAllCaps` prop instead
   */ allCaps: deprecatedProp(PropTypes.bool, 'Use `textAllCaps` prop instead.')
};
const Callout = createComponent({
    displayName: 'Callout',
    root: 'span',
    propTypes,
    propConfig: {
        derivedProps (props) {
            const { skin = 'standard', border = 'standard', variant = 'standard', sizeVariant = 'standard', size = sizeVariant, allCaps = false } = props;
            return {
                skin,
                border,
                variant,
                size,
                allCaps
            };
        },
        classNames (_props, derivedProps) {
            const { skin, border, variant, allCaps, size } = derivedProps;
            const classNameSet = new Set([
                'swan-callout'
            ]);
            if (skin !== 'standard') classNameSet.add(`swan-callout-skin-${skin}`);
            if (border === 'none') classNameSet.add('swan-callout-borderless');
            if (variant === 'overlay') classNameSet.add('swan-callout-overlay');
            if (variant === 'inverse') classNameSet.add('swan-callout-inverse');
            if (size === 'mini') classNameSet.add('swan-callout-mini');
            if (allCaps) classNameSet.add('swan-text-all-caps');
            return classNameSet;
        }
    }
});
Callout.defaultProps = {
    variant: 'standard',
    size: 'standard',
    skin: 'standard',
    border: 'standard'
};

export { Callout };
